<template>
	<v-app>
		<router-view></router-view>

		<v-snackbar v-model="success" :timeout="4000" color="success">{{ success }}</v-snackbar>
		<v-snackbar v-model="error" :timeout="4000" color="error">{{ error }}</v-snackbar>
	</v-app>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		name: 'App',
		components: {},
		computed: {
			error: {
				get() {
					return this.$store.state.Common.error
				},
				set(value) {
					if(!value){
						this.setError('')
					}
				}
			},

			success: {
				get() {
					return this.$store.state.Common.success
				},
				set(value) {
					if(!value){
						this.setSuccess('')
					}
				}
			}
		},

		methods: {
			...mapActions('Common', [ 'setError', 'setSuccess' ]),
		}
	}
</script>